module.exports = __webpack_public_path__ + "img/stock7.cf6ebe28.png";